<template>
    <div style="min-width: 400px; max-width: 600px; position: relative">
        <template v-if="loading">
            <div class="fill-height d-flex align-center justify-center">
                <app-centre-loader label="Loading Top 10 Apps"></app-centre-loader>
            </div>
        </template>
        <template v-else>
            <div
                    class="text-center text-h6 font-weight-thin"
            >
                Top 10 Apps Today
            </div>
            <div style="position: relative;">
                <apex-chart type="donut" :options="chartOptions" :series="series"></apex-chart>
            </div>
        </template>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {arrSplice, durationDisplay, hourDisplay, hourDisplayWithoutUnit} from "@/core/codeFunctions";
import AppIcon from "@/components/Shared/AppIcon";
import {mapActions, mapGetters} from "vuex";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
export default {
    components: {
        AppCentreLoader,
        AppIcon,
        apexChart: VueApexCharts,
    },
    props: {
        propName: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: true,
            stats: [],
            gradient: ["var(--v-primary-lighten1)", "var(--v-primary-darken2)"],
            refreshInterval: null,
            hourDisplayWithoutUnit,
            hourDisplay,
            // resetPie:
            labels: [],
            series: [],
            chartOptions: null,
        }
    },
    mounted() {
        this.loadProductivity();
        this.refreshInterval = setInterval(() => {
            this.loadProductivity()
        }, 60000)
    },
    beforeDestroy() {
        clearInterval(this.refreshInterval)
    },
    methods: {
        ...mapActions(['gotoAppStats']),
        async loadProductivity() {

            try {
                this.stats = await this.$newReq('GET', 'dashboard/stats/topAppsGraph')
                arrSplice(this.labels, () => true)
                this.labels.splice(0,0, ...this.stats.map(stat => stat.key))
                arrSplice(this.series, () => true)
                this.series.splice(0,0, ...this.stats.map(stat => stat.value))
                if (!this.chartOptions) {
                    const rawColors = ['green', 'red', 'blue', 'amber', 'green', 'pink', 'purple', 'deep-orange', 'indigo', 'light-blue', 'cyan', 'light-green', 'lime', 'deep-purple', 'amber', 'teal', 'indigo', 'orange', 'yellow', 'brown',]
                    this.chartOptions = {
                        colors: rawColors.map(color => `var(--v-${color}-base)`),
                        chart: {
                            width: 380,
                            type: 'donut',
                        },
                        plotOptions: {
                            pie: {
                                startAngle: -90,
                                endAngle: 270,
                                customScale: 1,
                            },
                            donut: {
                                size: '20%',
                                background: 'green',
                            },

                        },
                        dataLabels: {
                            enabled: false
                        },
                        labels: this.labels,
                        fill: {
                            type: 'gradient',
                            gradient: {
                                shade: 'dark',
                                type: "horizontal",
                                shadeIntensity: 0.5,
                                gradientToColors: rawColors.map(color => `var(--v-${color}-darken6)`),
                                inverseColors: true,
                                stops: [0, 100],
                                // colorStops: [],
                            },
                        },
                        stroke: {
                            show: false
                        },
                        tooltip: {
                            fillSeriesColor: true,
                            y: {
                                show: true,
                                formatter: (val) => {return hourDisplay(val)},
                            },
                        },
                        legend: {
                            position: 'bottom',
                            // floating: true,
                            formatter: function(val, opts) {
                                return val + " - " + hourDisplay(opts.w.globals.series[opts.seriesIndex])
                            },
                            labels: {
                                colors: ['#fff'],
                                // useSeriesColors: true
                            },
                        },
                    }
                }
                this.loading = false
            } catch (e) {
                console.log(e)
            }
        }
    },
    computed: {
        ...mapGetters(['labelsRef']),
    }
}
</script>

<style scoped>

.txt:hover {
    text-decoration: underline;
    color: #fff !important;
    cursor: pointer;
}

</style>